import { Icon } from '@iconify/react';
import AnimatedSection from '../components/ui/AnimatedSection';
import PageBanner from '../components/layout/PageBanner';

export default function Perfil(){
    return(
        <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Perfil"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Perfil' },
              ]}
            />
            <div className="max-w-4xl mx-auto px-4 py-12">
                <AnimatedSection className="max-w-lg mx-auto text-center">
                    <div className="w-20 h-20 rounded-full bg-[#f26724] flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#f26724]/20">
                        <Icon icon="mdi:account" className="text-4xl text-white" />
                    </div>
                    <h2 className="text-2xl font-bold text-[#f26724] mb-2">Usuario Demo</h2>
                    <p className="text-gray-500 mb-8">usuario@scalar.pe</p>
                    <div className="bg-white border border-black/10 rounded-2xl p-6 text-left space-y-4">
                        <div className="flex items-center justify-between pb-4 border-b border-black/10">
                            <span className="text-gray-500 text-sm">Nombre</span>
                            <span className="text-[#2d2d44] font-medium">Usuario Demo</span>
                        </div>
                        <div className="flex items-center justify-between pb-4 border-b border-black/10">
                            <span className="text-gray-500 text-sm">Correo</span>
                            <span className="text-[#2d2d44] font-medium">usuario@scalar.pe</span>
                        </div>
                        <div className="flex items-center justify-between pb-4 border-b border-black/10">
                            <span className="text-gray-500 text-sm">Teléfono</span>
                            <span className="text-[#2d2d44] font-medium">+51 999 999 999</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-gray-500 text-sm">Empresa</span>
                            <span className="text-[#2d2d44] font-medium">Scalar</span>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
        </main>
    )
}
